import { faPlus } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import './SidebarCreateButton.css'

type Props = {
  text: string
  onClick: () => void
}

const SidebarCreateButton = ({text, onClick}: Props) => {
  return <div className="sidebar-create-button" onClick={onClick}>
    <div className="sidebar-create-button-circle">
      <FontAwesomeIcon icon={faPlus} size="3x" />
    </div>
    <span>{text}</span>
  </div>
}

export default SidebarCreateButton